'use strict';

(function () {
	angular.module('lodash', []);
})();